// extracted by mini-css-extract-plugin
export default {"notesContainer":"X9Ep2Z","testNotesActionsContainer":"EoEgU8"};